import { Component, EventEmitter, Output, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-diagram-help-modal',
  standalone: true,
  imports: [],
  templateUrl: './diagram-help-modal.component.html',
  styleUrl: './diagram-help-modal.component.scss',
})
export class DiagramHelpModalComponent implements AfterViewInit {
  @Output() close = new EventEmitter<void>();
  @ViewChild('dialog', { static: true }) dialog!: ElementRef<HTMLDialogElement>;

  ngAfterViewInit(): void {
    this.openModal();
  }

  onDialogClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.closeModal();
    }
  }

  onDialogKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.closeModal();
    }
  }

  closeModal(): void {
    this.dialog.nativeElement.close();
    this.close.emit();
  }

  openModal(): void {
    this.dialog.nativeElement.showModal();
    this.dialog.nativeElement.focus();
  }
}
